import { Link } from "@tanstack/react-router";
import { Faq } from "@/components/faq";
import { HOME_FAQ_ITEMS } from "./home-faq";

/** The questions most people arrive with; the rest sit one tap away, still on the page. */
const FIRST = 6;

export function HomeFaq() {
  return (
    <section aria-labelledby="home-faq" className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
      <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1 border-t border-rule pt-3">
        <h2 id="home-faq" className="label-caps text-muted-foreground">
          Common questions
        </h2>
        <p className="text-sm text-muted-foreground">
          Something we haven&rsquo;t answered?{" "}
          <Link to="/contact" className="link">
            Ask us
          </Link>
          .
        </p>
      </div>
      <div className="mt-4 max-w-3xl">
        <Faq items={HOME_FAQ_ITEMS.slice(0, FIRST)} />
        <details className="group">
          <summary className="cursor-pointer py-4 text-sm font-semibold text-primary">
            <span className="group-open:hidden">
              {HOME_FAQ_ITEMS.length - FIRST} more questions
            </span>
            <span className="hidden group-open:inline">Fewer questions</span>
          </summary>
          <Faq items={HOME_FAQ_ITEMS.slice(FIRST)} />
        </details>
      </div>
    </section>
  );
}
